export const AntennaValidationMessages = {
    scheduleDsMustHaveAtLeastOneAntenna:
        'All locations must have at least one antenna.',

    heightGreaterThanScheduleDHeight:
        'Must be <= the height with appurtenances.',
} as const;
